<mat-card>
  <div class="add-tool-align">
    <div [matTooltipDisabled]="false"
      [ngClass]="{'disabled-cursor': !tourGuideService.isStartTour && !authService.permissions['add-tool']}"
      matTooltip="{{!authService.permissions['add-tool'] ? commonService.messages.permissionMsg:''}}">
      <button mat-raised-button color="primary"
        [disabled]="!tourGuideService.isStartTour && !authService.permissions['add-tool']"
        [id]="tourGuideIds.adminContent.tools.addTool.id" class="btn-space" (click)="openToolModal('','add')">Add
        tool</button>
    </div>
    <app-add-tool [toolData]="selectedRowData" [addtool]='addtools' [showModal]="showModal"
      (closeModal)="onCloseModal()" (dataSaved)="refreshViewTool($event)"></app-add-tool>
  </div>
  <div class="table-overflow">
    <app-view-tool [dataSource]="dataSource" (editRow)="openToolModal($event,'edit')"></app-view-tool>
  </div>
</mat-card>